import * as React from 'react'
import { Link } from 'react-router'
import { styles } from './styles.css'

type CommonProps = {
  size?: 's' | 'm'
  tone?: 'normal' | 'primary' | 'secondary' | 'danger'
  fluid?: boolean
  className?: string
}

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & CommonProps & { as: 'button' }
type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & CommonProps & { as: 'a' }
type Props = ButtonProps | AnchorProps

export const Button: React.FC<Props> = ({ children, size = 'm', tone = 'normal', fluid = false, className, ...rest }) => {
  const classNames = [
    styles.button,
    size === 's' ? styles.small : null,
    size === 'm' ? styles.medium : null,
    tone === 'primary' ? styles.primary : null,
    tone === 'secondary' ? styles.secondary : null,
    tone === 'danger' ? styles.danger : null,
    fluid ? styles.fluid : null,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  if (rest.as === 'a') {
    const { href, ...restProps } = rest
    return (
      <Link to={href} className={classNames} {...restProps}>
        {children}
      </Link>
    )
  } else {
    return (
      <button className={classNames} {...rest}>
        {children}
      </button>
    )
  }
}
